var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      staticClass: "mx-3 mt-2",
      model: {
        value: _vm.searchParamsValid,
        callback: function($$v) {
          _vm.searchParamsValid = $$v
        },
        expression: "searchParamsValid"
      }
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Autonumero",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.updatedSearchParams.carNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "carNumber", $$v)
                  },
                  expression: "updatedSearchParams.carNumber"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  label: "Palvelutunnus",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.updatedSearchParams.serviceNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "serviceNumber", $$v)
                  },
                  expression: "updatedSearchParams.serviceNumber"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center justify-center py-0",
              attrs: { cols: "1", sm: "0" }
            },
            [_c("v-divider", { attrs: { inset: "", vertical: "" } })],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Tilaustunnus",
                  clearable: "",
                  "hide-details": ""
                },
                on: {
                  input: function($event) {
                    _vm.updatedSearchParams.orderId = _vm.updatedSearchParams
                      .orderId
                      ? _vm.updatedSearchParams.orderId.toUpperCase()
                      : _vm.updatedSearchParams.orderId
                  }
                },
                model: {
                  value: _vm.updatedSearchParams.orderId,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "orderId", $$v)
                  },
                  expression: "updatedSearchParams.orderId"
                }
              }),
              _c("v-text-field", {
                attrs: {
                  label: "Kuittinumero",
                  clearable: "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.updatedSearchParams.receiptNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "receiptNumber", $$v)
                  },
                  expression: "updatedSearchParams.receiptNumber"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "6", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Myyntilaskun numero" },
                model: {
                  value: _vm.updatedSearchParams.salesInvoiceNumbers,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.updatedSearchParams,
                      "salesInvoiceNumbers",
                      $$v
                    )
                  },
                  expression: "updatedSearchParams.salesInvoiceNumbers"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "6", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Ostolaskun numero" },
                model: {
                  value: _vm.updatedSearchParams.purchaseInvoiceNumbers,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.updatedSearchParams,
                      "purchaseInvoiceNumbers",
                      $$v
                    )
                  },
                  expression: "updatedSearchParams.purchaseInvoiceNumbers"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "4" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "pt-0",
                  attrs: {
                    outlined: !_vm.hasFailedValidationsActive,
                    color: _vm.hasFailedValidationsActive ? "primary" : "",
                    small: ""
                  },
                  on: { click: _vm.toggleFailedValidations }
                },
                [_vm._v(" Virheessä olevat matkat ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-0",
                  attrs: { text: "", small: "" },
                  on: {
                    click: function($event) {
                      _vm.showInvoiceStates = !_vm.showInvoiceStates
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.showInvoiceStates
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      )
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showInvoiceStates
                          ? "Piilota tilasuodattimet"
                          : "Näytä tilasuodattimet"
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showInvoiceStates,
                expression: "showInvoiceStates"
              }
            ]
          },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "8" } },
                  [
                    _c("ValidationStatesField", {
                      attrs: {
                        validationStates:
                          _vm.updatedSearchParams.validationStates
                      },
                      on: {
                        "update:validationStates": function(newValues) {
                          return (_vm.updatedSearchParams.validationStates = newValues)
                        }
                      }
                    }),
                    _c(
                      "v-slide-y-transition",
                      [
                        _vm.updatedSearchParams.validationStates.length === 1 &&
                        _vm.updatedSearchParams.validationStates.includes(
                          _vm.validationStatusTypes.New
                        )
                          ? _c(
                              "v-item-group",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c("v-item", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var active = ref.active
                                              var toggle = ref.toggle
                                              return [
                                                _c("v-checkbox", {
                                                  attrs: {
                                                    value: (_vm.updatedSearchParams.missingTrip = active),
                                                    label: "Tilaus puuttuu",
                                                    ripple: false
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return toggle($event)
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        739395960
                                      )
                                    }),
                                    _c("v-item", {
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var active = ref.active
                                              var toggle = ref.toggle
                                              return [
                                                _c("v-checkbox", {
                                                  staticClass: "ml-4",
                                                  attrs: {
                                                    value: (_vm.updatedSearchParams.missingCharge = active),
                                                    label: "Kuitti puuttuu",
                                                    ripple: false
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return toggle($event)
                                                    }
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        629288749
                                      )
                                    }),
                                    _c("v-spacer")
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("SalesInvoiceStatesField", {
                      attrs: {
                        updatedSearchParams:
                          _vm.updatedSearchParams.salesInvoiceStates,
                        disabled: !!_vm.updatedSearchParams.salesInvoiceNumbers
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.salesInvoiceStates = newValues)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("PurchaseInvoiceStatesField", {
                      attrs: {
                        updatedSearchParams:
                          _vm.updatedSearchParams.purchaseInvoiceStates,
                        disabled: !!_vm.updatedSearchParams
                          .purchaseInvoiceNumbers
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.purchaseInvoiceStates = newValues)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "12", sm: "4" } },
                  [
                    _c("ProvisionInvoiceStatesField", {
                      attrs: {
                        updatedSearchParams:
                          _vm.updatedSearchParams.provisionInvoiceStates
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.provisionInvoiceStates = newValues)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
            [_vm._v("Matkan aloitus")]
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: { label: "Alkaen", type: "date", max: "2099-12-31" },
                model: {
                  value: _vm.updatedSearchParams.tripStartedFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripStartedFrom", $$v)
                  },
                  expression: "updatedSearchParams.tripStartedFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "pl-0 py-0",
              attrs: { cols: "12", sm: "6", md: "3" }
            },
            [
              _c("v-text-field", {
                attrs: { label: "Päättyen", type: "date", max: "2099-12-31" },
                model: {
                  value: _vm.updatedSearchParams.tripStartedTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "tripStartedTo", $$v)
                  },
                  expression: "updatedSearchParams.tripStartedTo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearDateRange("tripStarted")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.clear")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-0",
                  attrs: { text: "", small: "" },
                  on: {
                    click: function($event) {
                      _vm.showMoreDateRanges = !_vm.showMoreDateRanges
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.showMoreDateRanges
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      )
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showMoreDateRanges
                          ? "Piilota päivämääräsuodattimet"
                          : "Näytä lisää päivämääräsuodattimia"
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMoreDateRanges,
                expression: "showMoreDateRanges"
              }
            ]
          },
          [
            _c(
              "v-row",
              { attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
                  [_vm._v("Matkan lopetus")]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0",
                    attrs: { cols: "12", sm: "6", md: "3" }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Alkaen",
                        type: "date",
                        max: "2099-12-31"
                      },
                      model: {
                        value: _vm.updatedSearchParams.tripEndedFrom,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "tripEndedFrom",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.tripEndedFrom"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0",
                    attrs: { cols: "12", sm: "6", md: "3" }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Päättyen",
                        type: "date",
                        max: "2099-12-31"
                      },
                      model: {
                        value: _vm.updatedSearchParams.tripEndedTo,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "tripEndedTo", $$v)
                        },
                        expression: "updatedSearchParams.tripEndedTo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            return _vm.clearDateRange("tripEnded")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.clear")))]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  { staticClass: "pl-0 py-0", attrs: { cols: "12", md: "2" } },
                  [_vm._v("Muokkausaika")]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0",
                    attrs: { cols: "12", sm: "6", md: "3" }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Alkaen",
                        type: "date",
                        max: "2099-12-31"
                      },
                      model: {
                        value: _vm.updatedSearchParams.modifiedFrom,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "modifiedFrom", $$v)
                        },
                        expression: "updatedSearchParams.modifiedFrom"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0",
                    attrs: { cols: "12", sm: "6", md: "3" }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Päättyen",
                        type: "date",
                        max: "2099-12-31"
                      },
                      model: {
                        value: _vm.updatedSearchParams.modifiedTo,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "modifiedTo", $$v)
                        },
                        expression: "updatedSearchParams.modifiedTo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            return _vm.clearDateRange("modified")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.clear")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0 mb-2", attrs: { cols: "12", md: "2" } },
            [_vm._v("Kustannus")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.costFrom,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "costFrom", $$v)
                  },
                  expression: "updatedSearchParams.costFrom"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "hidden-xs-only py-0 pb-3",
              staticStyle: { "font-size": "1.5em" },
              attrs: { sm: "auto" }
            },
            [_vm._v(" - ")]
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
            [
              _c("v-text-field", {
                staticClass: "pt-0 centered-input",
                staticStyle: { width: "70px" },
                attrs: {
                  "single-line": "",
                  type: "number",
                  placeholder: "-",
                  variant: "outlined",
                  dense: ""
                },
                model: {
                  value: _vm.updatedSearchParams.costTo,
                  callback: function($$v) {
                    _vm.$set(_vm.updatedSearchParams, "costTo", $$v)
                  },
                  expression: "updatedSearchParams.costTo"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearFinancialRange("cost")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.clear")))]
              )
            ],
            1
          ),
          _c("v-spacer")
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-0",
                  attrs: { text: "", small: "" },
                  on: {
                    click: function($event) {
                      _vm.showMoreFinancialRanges = !_vm.showMoreFinancialRanges
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.showMoreFinancialRanges
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      )
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showMoreFinancialRanges
                          ? "Piilota hintasuodattimet"
                          : "Näytä lisää hintasuodattimia"
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMoreFinancialRanges,
                expression: "showMoreFinancialRanges"
              }
            ]
          },
          [
            _c(
              "v-row",
              { attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0 mb-2",
                    attrs: { cols: "12", md: "2" }
                  },
                  [_vm._v("Korvaus")]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
                  [
                    _c("v-text-field", {
                      staticClass: "pt-0 centered-input",
                      staticStyle: { width: "70px" },
                      attrs: {
                        "single-line": "",
                        type: "number",
                        placeholder: "-",
                        variant: "outlined",
                        dense: ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.reimbursementFrom,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "reimbursementFrom",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.reimbursementFrom"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "hidden-xs-only py-0 pb-3",
                    staticStyle: { "font-size": "1.5em" },
                    attrs: { sm: "auto" }
                  },
                  [_vm._v(" - ")]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
                  [
                    _c("v-text-field", {
                      staticClass: "pt-0 centered-input",
                      staticStyle: { width: "70px" },
                      attrs: {
                        "single-line": "",
                        type: "number",
                        placeholder: "-",
                        variant: "outlined",
                        dense: ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.reimbursementTo,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "reimbursementTo",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.reimbursementTo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            return _vm.clearFinancialRange("reimbursement")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.clear")))]
                    )
                  ],
                  1
                ),
                _c("v-spacer")
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "pl-0 py-0 mb-2",
                    attrs: { cols: "12", md: "2" }
                  },
                  [_vm._v("Omavastuu")]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
                  [
                    _c("v-text-field", {
                      staticClass: "pt-0 centered-input",
                      staticStyle: { width: "70px" },
                      attrs: {
                        "single-line": "",
                        type: "number",
                        placeholder: "-",
                        variant: "outlined",
                        dense: ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.deductibleFrom,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "deductibleFrom",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.deductibleFrom"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "hidden-xs-only py-0 pb-3",
                    staticStyle: { "font-size": "1.5em" },
                    attrs: { sm: "auto" }
                  },
                  [_vm._v(" - ")]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "6", sm: "auto" } },
                  [
                    _c("v-text-field", {
                      staticClass: "pt-0 centered-input",
                      staticStyle: { width: "70px" },
                      attrs: {
                        "single-line": "",
                        type: "number",
                        placeholder: "-",
                        variant: "outlined",
                        dense: ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.deductibleTo,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "deductibleTo", $$v)
                        },
                        expression: "updatedSearchParams.deductibleTo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", attrs: { cols: "12", sm: "2" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "" },
                        on: {
                          click: function($event) {
                            return _vm.clearFinancialRange("deductible")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.clear")))]
                    )
                  ],
                  1
                ),
                _c("v-spacer")
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-row",
        { staticClass: "mt-4" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0 py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { outlined: "", block: "" },
                  on: {
                    click: function($event) {
                      _vm.showMoreSearchFilters = !_vm.showMoreSearchFilters
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.showMoreSearchFilters
                          ? "mdi-filter-minus-outline"
                          : "mdi-filter-plus-outline"
                      )
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.showMoreSearchFilters
                          ? "Piilota hakusuodattimet"
                          : "Näytä lisää hakusuodattimia"
                      ) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showMoreSearchFilters,
                expression: "showMoreSearchFilters"
              }
            ]
          },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Hetu",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.ssn,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "ssn", $$v)
                        },
                        expression: "updatedSearchParams.ssn"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Kortin numero",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.cardNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "cardNumber", $$v)
                        },
                        expression: "updatedSearchParams.cardNumber"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Taksamittarin sarjanumero",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.taximeterSerialNumber,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "taximeterSerialNumber",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.taximeterSerialNumber"
                      }
                    }),
                    _c("MeterTypesField", {
                      attrs: {
                        updatedSearchParams: _vm.updatedSearchParams.meterTypes
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.meterTypes = newValues)
                        }
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Operaattorin tunniste",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.operatorId,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "operatorId", $$v)
                        },
                        expression: "updatedSearchParams.operatorId"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Ulkoisen järjestelmän viitenumero",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.referenceNumber,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.updatedSearchParams,
                            "referenceNumber",
                            $$v
                          )
                        },
                        expression: "updatedSearchParams.referenceNumber"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "d-flex align-center justify-center py-0",
                    attrs: { cols: "1", sm: "0" }
                  },
                  [_c("v-divider", { attrs: { inset: "", vertical: "" } })],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "pl-0 py-0", attrs: { cols: "12", sm: "5" } },
                  [
                    _c("PaymentMethodField", {
                      attrs: {
                        updatedSearchParams:
                          _vm.updatedSearchParams.paymentMethods
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.paymentMethods = newValues)
                        }
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Kustannuspaikka",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.costCenter,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "costCenter", $$v)
                        },
                        expression: "updatedSearchParams.costCenter"
                      }
                    }),
                    _c("EventTypeField", {
                      attrs: {
                        updatedSearchParams: _vm.updatedSearchParams.eventTypes
                      },
                      on: {
                        "update:updatedSearchParams": function(newValues) {
                          return (_vm.updatedSearchParams.eventTypes = newValues)
                        }
                      }
                    }),
                    _c("v-switch", {
                      attrs: { label: "Yhdistelymatka", "hide-details": "" },
                      model: {
                        value: _vm.carPoolToggle,
                        callback: function($$v) {
                          _vm.carPoolToggle = $$v
                        },
                        expression: "carPoolToggle"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Matkan tyyppi",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.tripType,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "tripType", $$v)
                        },
                        expression: "updatedSearchParams.tripType"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Reitin tunnus",
                        clearable: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.updatedSearchParams.routeId,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "routeId", $$v)
                        },
                        expression: "updatedSearchParams.routeId"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "v-row",
              { staticClass: "mt-2" },
              [
                _c(
                  "v-col",
                  { staticClass: "pl-0 py-0", attrs: { cols: "12" } },
                  [
                    _c("v-switch", {
                      attrs: { label: "Etsi myös poistettuja tapahtumia" },
                      model: {
                        value: _vm.updatedSearchParams.removed,
                        callback: function($$v) {
                          _vm.$set(_vm.updatedSearchParams, "removed", $$v)
                        },
                        expression: "updatedSearchParams.removed"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }